import React, { Component } from 'react';

import { api } from '../../../services/api';
import { titleCase } from '../../base/common/utils';

import './dashboard.scss';

class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.Api = api;

    this.state = {
      repos: {
        backend: {},
        widgets: {},
        storeroom: {},
      },
    };

    this.getAllGithashes.bind(this);
  }

  componentDidMount() {
    this.getAllGithashes();
  }

  getAllGithashes() {
    const queries = [
      this.Api.get('/api/v0/widgets/githash/'),
      this.Api.get('/api/v0/admins/githash/'),
    ];

    Promise.all(queries).then(results => {
      this.setState({
        repos: {
          backend: results[0].data.info.revision,
          widgets: results[0].data.data[0],
          storeroom: {
            // storeroom does not support timestamp
            hash: results[1].data.data[0]['X-BAM-BUILD-VERSION'],
          },
        },
      });
    });
  }

  render() {
    const githashes = Object.keys(this.state.repos).map(repoKey => {
      const repo = this.state.repos[repoKey];
      const timestamp = repo.timestamp ? (
        <div className="timestamp">Timestamp: {repo.timestamp}</div>
      ) : null;
      return (
        <div className="githash-container" key={repoKey}>
          <h3 className="repo">{titleCase(repoKey)}</h3>
          <div className="githash">Githash: {repo.hash}</div>
          {timestamp}
        </div>
      );
    });

    return <div className="admin-dashboard">{githashes}</div>;
  }
}

export default Dashboard;
